export enum WSBridgeDataUpdatePolicy {
  None = 0,
  Once = 1,
  Always = 2,
}

export enum WSBridgeCameraImageType {
  JPEG = 0,
  PNG = 1,
}

export interface WSBridgeCameraData {
  timestamp: number;
  viewMatrix: number[];
  projectionMatrix: number[];
  imageType: WSBridgeCameraImageType;
}

export interface WSBridgeAnchorData {
  uuid: string;
  changed: boolean;
  modelMatrix?: number[];
  vertices?: number[];
  indices?: number[];
}

export interface WSBridgeMeshData extends WSBridgeAnchorData {
  // same.
}

export interface WSBridgePlaneData extends WSBridgeAnchorData {
  extent?: number[];
}

export interface WSBridgeFrameMetadata {
  uuid: string;
  cameraData?: WSBridgeCameraData;
  planeData?: WSBridgePlaneData[];
  meshData?: WSBridgeMeshData[];
}

export interface WSBridgeFrameData {
  metadata?: WSBridgeFrameMetadata | null;
  imageBitmap?: ImageBitmap | null;
  image?: HTMLImageElement | null;
}